import React from "react";
import { useNavigate } from "react-router-dom";
import {
  usePermission,
  SystemPermissions,
} from "../../../Utils/permissionAccess";

function HomeScreen() {
  const navigate = useNavigate();
  const { hasPermission } = usePermission();

  const canReadHouseDesign = hasPermission(
    SystemPermissions.HomeScreenHouseDesign.READ,
  );
  const canReadCalculators = hasPermission(
    SystemPermissions.HomeScreenConsturctionCalculaotr.READ,
  );
  const canReadShop = hasPermission(
    SystemPermissions.HomeScreenConsturctionShop.READ,
  );
  const canReadProjects = hasPermission(
    SystemPermissions.HomeScreenConsturctionOurProjects.READ,
  );
  const canReadBlogs = hasPermission(
    SystemPermissions.HomeScreenConsturctionBlogs.READ,
  );
  const canReadInteriorDesign = hasPermission(
    SystemPermissions.HomeScreenInteriorDesign.READ,
  );

  const handleButtonClick = (value) => {
    navigate("/data-management", { state: { value } });
  };

  return (
    <div className="flex flex-col p-5">
      <div className="grid grid-cols-2 gap-6 w-full">
        {canReadHouseDesign && (
          <button
            className="btn btn-primary h-[80px] text-xl font-semibold rounded-2xl flex items-center justify-center"
            onClick={() => handleButtonClick("houseDesign")}
          >
            House Design
          </button>
        )}
        {canReadCalculators && (
          <button
            className="btn btn-primary h-[80px] text-xl font-semibold rounded-2xl flex items-center justify-center"
            onClick={() => handleButtonClick("construction")}
          >
            Construction Calculators
          </button>
        )}
        {canReadShop && (
          <button
            className="btn btn-primary h-[80px] text-xl font-semibold rounded-2xl flex items-center justify-center"
            onClick={() => handleButtonClick("shop")}
          >
            Shop
          </button>
        )}
        {canReadProjects && (
          <button
            className="btn btn-primary h-[80px] text-xl font-semibold rounded-2xl flex items-center justify-center"
            onClick={() => handleButtonClick("projects")}
          >
            Our Projects
          </button>
        )}
        {/* <button
          className="btn btn-primary h-[80px] text-xl font-semibold rounded-2xl flex items-center justify-center"
          onClick={() => handleButtonClick("frontElevation")}
        >
          Front Elevation
        </button> */}
        {canReadBlogs && (
          <button
            className="btn btn-primary h-[80px] text-xl font-semibold rounded-2xl flex items-center justify-center"
            onClick={() => handleButtonClick("blog")}
          >
            Blogs
          </button>
        )}
        {canReadInteriorDesign && (
          <button
            className="btn btn-primary h-[80px] text-xl font-semibold rounded-2xl flex items-center justify-center"
            onClick={() => handleButtonClick("interiorDesign")}
          >
            Interior Design
          </button>
        )}
      </div>
    </div>
  );
}

export default HomeScreen;
